export default "__VITE_ASSET__ffd750a5__"